import React from 'react';

// Iter 257 — Anti « page blanche » : toute erreur JS dans l'admin affiche un écran clair
// avec le détail technique (à transmettre au support) au lieu d'un écran vide.
class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ADMIN CRASH]', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="max-w-xl mx-auto my-12 bg-white border-2 border-red-300 rounded-2xl p-6 text-center" data-testid="admin-error-boundary">
        <p className="text-3xl">😬</p>
        <p className="text-lg font-bold text-[#1E3A5F] mt-2">Oups, une erreur d'affichage est survenue</p>
        <p className="text-sm text-gray-600 mt-1">
          Vos données sont intactes. Cliquez sur le bouton ci-dessous pour repartir proprement.
        </p>
        <button
          onClick={() => {
            try { localStorage.removeItem('admin_active_tab'); } catch { /* ignore */ }
            window.location.reload();
          }}
          className="mt-4 px-5 py-2.5 bg-[#1E3A5F] text-white font-bold rounded-xl"
          data-testid="admin-error-reload">
          🔄 Recharger l'administration
        </button>
        <details className="mt-4 text-left">
          <summary className="text-[11px] text-gray-400 cursor-pointer">Détail technique (à transmettre si ça se reproduit)</summary>
          <pre className="text-[10px] text-red-700 whitespace-pre-wrap mt-1 bg-red-50 rounded-lg p-2 max-h-40 overflow-auto">
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        </details>
      </div>
    );
  }
}

export default AdminErrorBoundary;
